module.exports = __webpack_public_path__ + "static/media/d-you-wallet-verify-en.a2014758.svg";